import GATSBY_COMPILED_MDX from "/vercel/path0/gatsby/content/blog/noadvantage-tiebreak/index.md";
import * as React from "react";
import {graphql} from "gatsby";
import {Link} from "gatsby";
import {GatsbyImage} from "gatsby-plugin-image";
import {MDXProvider} from "@mdx-js/react";
import {RacketDataProvider} from "../context";
import Bio from "../components/bio";
import Layout from "../components/layout";
import Seo from "../components/seo";
import ArticleSchema from "../components/schema/article";
import ItemComponent from "../components/item";
import RacketDataComponent from "../components/RacketDataComponent";
import BlogPostTopItem from "../components/BlogPostTopItem";
import Sidebar from "../components/Sidebar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faHistory} from "@fortawesome/free-solid-svg-icons";
import {faTwitter} from "@fortawesome/free-brands-svg-icons";
library.add(faTwitter);
library.add(faHistory);
const H2 = ({children}) => {
  const id = children.toString().replace(/\s+/g, "-").toLowerCase();
  return React.createElement("h2", {
    id: id
  }, children);
};
const components = {
  h2: H2,
  Item: ItemComponent,
  RacketData: RacketDataComponent
};
const BlogPostTemplate = ({data, location, children}) => {
  const post = data.mdx;
  const popularPosts = data.popularPosts.nodes;
  const siteTitle = data.site.siteMetadata?.title || `Title`;
  const siteUrl = data.site.siteMetadata?.siteUrl || `URL`;
  const {previous, next, channel} = data;
  const thumbnail = post.frontmatter.thumbnail;
  const tags = post.frontmatter.tags;
  const Iframe = () => {
    return post.frontmatter.youtubeId ? React.createElement("div", {
      className: "mt-10 mx-auto max-w-screen-sm"
    }, React.createElement("iframe", {
      width: "100%",
      height: "325",
      className: "m-auto",
      src: `https://www.youtube.com/embed/${post.frontmatter.youtubeId}`,
      title: "YouTube video player",
      frameBorder: "0",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowFullScreen: true
    })) : React.createElement(React.Fragment);
  };
  const Channel = () => {
    return channel.frontmatter.name ? React.createElement("div", {
      className: "mt-10 mx-auto max-w-screen-sm"
    }, React.createElement("a", {
      target: "_blank",
      rel: "noopener noreferrer",
      className: "duration-200 hover:text-blue-500",
      href: `https://www.youtube.com/channel/${channel.frontmatter.youtubeId}`
    }, channel.frontmatter.name)) : React.createElement(React.Fragment);
  };
  const Rewrite = () => {
    return post.frontmatter.rewrite ? React.createElement("span", {
      className: "ml-4"
    }, React.createElement(FontAwesomeIcon, {
      width: "16",
      height: "16",
      className: "mr-1",
      icon: faHistory
    }), React.createElement("time", {
      dateTime: post.frontmatter.rewrite,
      itemProp: "dateModified"
    }, post.frontmatter.rewrite)) : React.createElement(React.Fragment);
  };
  return React.createElement(Layout, {
    location: location,
    title: siteTitle
  }, React.createElement(Seo, {
    title: post.frontmatter.title,
    description: post.frontmatter.description || post.excerpt,
    thumbnail: thumbnail
  }), React.createElement(ArticleSchema, {
    post: post,
    thumbnail: thumbnail
  }), React.createElement("div", {
    className: "w-full bg"
  }, React.createElement("div", {
    className: "w-full sm:w-11/12 max-w-screen-xl mx-auto block sm:flex flex-wrap justify-center"
  }, React.createElement("div", {
    className: "main"
  }, React.createElement("div", {
    className: "main_content"
  }, React.createElement("article", {
    className: "",
    itemScope: true,
    itemType: "http://schema.org/Article"
  }, React.createElement("div", {
    className: "post-container"
  }, React.createElement("div", {
    className: "max-w-screen-lg w-full md:w-11/12 lg:w-10/12 m-auto"
  }, React.createElement("p", null, React.createElement(Link, {
    to: `/category/${post.frontmatter.category}`,
    className: "bg-black text-white p-1 mr-2 rounded-md font-bold"
  }, post.frontmatter.category), React.createElement("span", {
    dateTime: post.frontmatter.date,
    itemProp: "datePublished"
  }, post.frontmatter.date), React.createElement(Rewrite)), React.createElement("h1", {
    className: "title",
    itemProp: "headline"
  }, post.frontmatter.title), React.createElement("div", {
    className: "text-center mt-4"
  }, React.createElement(GatsbyImage, {
    image: post.frontmatter.thumbnail?.childImageSharp.gatsbyImageData,
    alt: post.frontmatter.title
  })), React.createElement("div", {
    className: "my-10"
  }, tags?.map(tag => React.createElement(Link, {
    key: tag,
    to: `/tag/${tag}`,
    className: "text-blue-600/100 text-sm border font-bold rounded-lg border-blue-600/100 p-2 mx-2 hover:bg-blue-600/100 hover:text-white duration-200"
  }, tag))), React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: post.frontmatter.description
    },
    className: "text-gray-700 text-md my-16"
  }), React.createElement("div", {
    className: "toc font-bold bg-indigo-50 rounded-lg"
  }, React.createElement("p", {
    className: "mb-4"
  }, "目次"), React.createElement("ol", null, post.tableOfContents?.items?.map(v => React.createElement("li", {
    className: "toc-h2",
    key: `toc-${v.title}`
  }, React.createElement("a", {
    href: v.url
  }, v.title)))))), React.createElement(BlogPostTopItem), React.createElement("div", null, React.createElement("div", {
    className: "blog w-12/12 max-w-screen-sm my-24 mx-auto",
    itemProp: "articleBody"
  }, React.createElement(RacketDataProvider, null, React.createElement(MDXProvider, {
    components: components
  }, children))), React.createElement(Iframe), React.createElement(Channel), React.createElement("div", {
    className: "text-center"
  }, React.createElement("a", {
    href: `https://twitter.com/share?url=${siteUrl}${post.fields.slug}&text=${post.frontmatter.title}&hashtags=テニス,ポッポテニスメディア`,
    rel: "noopener noreferrer",
    target: "_blank",
    className: "text-blue-500"
  }, React.createElement(FontAwesomeIcon, {
    icon: faTwitter
  }), "ぜひシェアをお願いします！")))), React.createElement("footer", null, React.createElement(Bio))), React.createElement("nav", {
    className: ""
  }, React.createElement("ul", {
    className: "text-center max-w-screen flex flex-wrap",
    style: {
      listStyle: `none`,
      padding: 0
    }
  }, React.createElement("li", {
    className: "hover:opacity-70 duration-200 px-5 w-max sm:w-6/12"
  }, previous && React.createElement(Link, {
    to: previous.fields.slug,
    rel: "prev"
  }, React.createElement("div", null, React.createElement(GatsbyImage, {
    image: previous.frontmatter.thumbnail?.childImageSharp.gatsbyImageData,
    alt: post.frontmatter.title
  })), React.createElement("p", {
    className: "font-bold text-left"
  }, previous.frontmatter.title))), React.createElement("li", {
    className: "hover:opacity-70 duration-200 px-5 w-max sm:w-6/12"
  }, next && React.createElement(Link, {
    to: next.fields.slug,
    rel: "next"
  }, React.createElement("div", null, React.createElement(GatsbyImage, {
    image: next.frontmatter.thumbnail?.childImageSharp.gatsbyImageData,
    alt: next.frontmatter.title
  })), React.createElement("p", {
    className: "font-bold text-left"
  }, next.frontmatter.title))))), React.createElement("div", {
    className: "mt-8 text-center"
  }, React.createElement(Link, {
    className: "bg-blue-600 text-sm md:text-base px-4 md:px-8 py-2 text-white rounded-2xl font-bold hover:text-blue-600 hover:bg-white border border-blue-600 duration-200",
    to: "/items/service"
  }, "テニス事業のWebページを作成したい方はこちら")))), React.createElement("div", {
    className: "sidebar"
  }, React.createElement(Sidebar, {
    popularPosts: popularPosts,
    relatedPosts: post.relatedPosts
  })))));
};
BlogPostTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogPostTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query BlogPostBySlug(
    $id: String!
    $channelId: Int
    $previousPostId: String
    $nextPostId: String
  ) {
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
    mdx(id: { eq: $id }) {
      id
      tableOfContents
      fields {
        slug
      }
      frontmatter {
        title
        date(formatString: "YYYY-MM-DD")
        rewrite(formatString: "YYYY-MM-DD")
        description
        channel
        category
        youtubeId
        thumbnail {
          childImageSharp {
            gatsbyImageData
          }
        }
        tags
      }
      relatedPosts {
        fields {
          slug
        }
        frontmatter {
          title
          thumbnail {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
    popularPosts: allMdx(
      filter: { fields: { slug: { eq: "/search/rackets/" } } }
    ) {
      nodes {
        fields {
          slug
        }
        frontmatter {
          title
          thumbnail {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
    channel: mdx(frontmatter: { channelId: { eq: $channelId } }) {
      frontmatter {
        name
        youtubeId
      }
    }
    previous: mdx(id: { eq: $previousPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
        thumbnail {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    next: mdx(id: { eq: $nextPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
        thumbnail {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
`;
